import { NgModule } from '@angular/core';

import { ReportsModule as CommonReportsModule } from '../Common/Reports/reports.module';
import { ReportsComponent } from './Core/components/Reports/reports.component';
import { ReportsCoreModule } from './Core/reports-core.module';
import { ReportsRoutingModule } from './ReportsRouter/reports-routing.module';

@NgModule({
    imports: [
        CommonReportsModule,
        ReportsCoreModule,
        ReportsRoutingModule
    ],
    exports: [
        ReportsComponent
    ]
})
export class ReportsModule { }
